import { ProjectState } from 'store/Project/ProjectTypes'

export function selectedFilterActive(
  bySelected: ProjectState['filters']['bySelected'],
) {
  return Boolean(
    bySelected?.active && bySelected.filter?.selectedPointers?.length > 0,
  )
}
